import { ICommand } from './ICommand';
import { getNodeMutationManager } from './mutations/NodeMutationManager';
import { Node } from '../models/scene';
import { useDiagramStore } from '../../stores/diagramStore';
import { validateShapeLimitOrPromptUpgrade } from '../../utils/shapeLimitUtils';

export class CreateNodeCommand implements ICommand {
  id: string;
  name = 'Create Node';
  description: string;
  timestamp = Date.now();

  private node: Node;

  constructor(node: Node) {
    this.id = `create-node-${Date.now()}`;
    this.node = node;
    this.description = `Create ${node.type || 'shape'}`;
  }

  getNode(): Node {
    return this.node;
  }

  execute(): void {
    // Check shape limits
    const storeSnapshot = useDiagramStore.getState();
    const isNew = !storeSnapshot.nodes.some(n => n.id === this.node.id);
    
    if (isNew && !validateShapeLimitOrPromptUpgrade(storeSnapshot)) {
      return; 
    }
    
    const mutationManager = getNodeMutationManager();
    try {
      console.debug('Debug SDI: CreateNodeCommand.execute addNode', {
        id: this.node?.id,
        type: this.node?.type,
        x: this.node?.x,
        y: this.node?.y,
        w: (this.node as any)?.w,
        h: (this.node as any)?.h
      });
    } catch {}
    mutationManager.addNode(this.node);
  }

  undo(): void {
    const mutationManager = getNodeMutationManager();
    try { console.debug('Debug SDI: CreateNodeCommand.undo deleteNode', { id: this.node?.id }); } catch {}
    mutationManager.deleteNode(this.node.id);
  }

  redo(): void {
    this.execute();
  }
}
